module.exports = __webpack_public_path__ + "img/FR_checkIntegrityResultTrue.ba8c9b80.png";